import { scan } from "react-scan"; // must be imported before React and React DOM
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router";
import "highlight.js/styles/nord.css";

import { TempoDevtools } from "tempo-devtools";
TempoDevtools.init();

scan({
  enabled: import.meta.env.VITE_SCAN === "true",
});

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
